/**
 * Created by Shikha Gupta on 2019-09-12
 */
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { IResizeData, StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { ArrayHelper } from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import { TimelineLite } from "gsap";
import {Container, Sprite, Graphics} from "pixi.js";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";


export class ForegroundAnimation extends BaseView {

    private _layer: Container;
    private static _animItems: TimelineSprite[][] = [];

    constructor() {
        super();
        this._layer = StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.FOREGROUND.name);
        this.addFeatureEventListeners();
    }

    public reset(): void {
        ForegroundAnimation._animItems.forEach((reelSymWinAnimations: TimelineSprite[], i: number) => {
            reelSymWinAnimations.forEach((symWinAnimations: TimelineSprite) => {
                symWinAnimations.stopLoop();
                // symWinAnimations.hide();
            });
        });
    }

    public static getSymbolAnimShow(reelId: number, symbolId: number): TimelineLite {
        let item: TimelineSprite;
        item = ForegroundAnimation._animItems[reelId][symbolId];
        item.blendMode = PIXI.BLEND_MODES.OVERLAY;
        return new TimelineLite().add(item.getAnimationAutoShowHide(true, false));


    }
    public static getStaticBgShow(reelId: number, symbolId: number): TimelineLite {

        let item: TimelineSprite;
        item = ForegroundAnimation._animItems[reelId][symbolId];
        item.blendMode = PIXI.BLEND_MODES.OVERLAY;

        return new TimelineLite().add(()=>{   item.show();
            item.setFrame(9);});
    }
    public static resetStaticBgShow(): TimelineLite {
        let item :TimelineSprite;
        for(let i=0;i<5;i++){
            for(let j=0;j<4;j++){
                item = ForegroundAnimation._animItems[i][j];
                item.blendMode = PIXI.BLEND_MODES.OVERLAY;
                item.hide();
                item.setFrame(0)
            }
        }
        return new TimelineLite().add(()=>{
        });
    }
    protected initAnimations(): void {
        ForegroundAnimation._animItems = ArrayHelper.initArrayWithValues(5, (i: number) => {
            const reelAnimations: TimelineSprite[] = ArrayHelper.initArrayWithValues(4, (j: number) => {
                return this.createAnimFrame(i, j);
            });
            return reelAnimations;
        });
    }

    private addFeatureEventListeners(): void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event: GameEvent) => this.reset());
    }

    protected onResize(data: IResizeData): void {

        ForegroundAnimation._animItems.forEach((reelSymWinAnimations: TimelineSprite[], i: number) => {
            reelSymWinAnimations.forEach((symWinAnimation: TimelineSprite, j: number) => {
                if(data.orientation =="portrait"){
                    symWinAnimation.position.set(Helper.getSymbolPositions(i, j)[0], Helper.getSymbolPositions(i, j)[1]-ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT/2-15);
                }else{
                    symWinAnimation.position.set(Helper.getSymbolPositions(i, j)[0], Helper.getSymbolPositions(i, j)[1]);

                }
            });
        });
    }


    private createAnimFrame(i: number, j: number): TimelineSprite {
        const winBackground = new TimelineSprite(GameResources.getTextures("symbolBgEffect"),16);
        winBackground.anchor.set(0.5, 0.5);
        winBackground.position.set(0, 0);
        winBackground.hide();
        winBackground.blendMode = PIXI.BLEND_MODES.OVERLAY;
        this._layer.addChild(winBackground);
        return winBackground;
    }
}